import { createContext, useState } from "react";

export const    AuthContext = createContext();

export const VendorAuthProvider = ({ children }) => {

  const [vendor, setVendor] = useState(() => {

    const token = localStorage.getItem("vendor_token");

    if (!token) return null;

    return {
      token: token,
      vendorId: localStorage.getItem("vendor_id"),
      phoneNumber: localStorage.getItem("vendor_phone")
    };

  });

  const login = (data) => {

    localStorage.setItem("vendor_token", data.token);
    localStorage.setItem("vendor_id", data.vendorId);
    localStorage.setItem("vendor_phone", data.phoneNumber);

    setVendor(data);
  };

  const logout = () => {

    localStorage.removeItem("vendor_token");
    localStorage.removeItem("vendor_id");
    localStorage.removeItem("vendor_phone");

    setVendor(null);
  };

  return (
    <AuthContext.Provider value={{ vendor, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};